import React, { useEffect } from 'react';

interface Props {
  to: string;
}

export const ExternalRedirect: React.FC<Props> = ({ to }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
};
